import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=2a945d77&scoped=true&"
import script from "./StatusChip.vue?vue&type=script&lang=js&"
export * from "./StatusChip.vue?vue&type=script&lang=js&"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=2a945d77&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a945d77",
  null
  
)

export default component.exports